/* HaPairComponent.js */

"use strict";
const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Registrations = require("../../../../../../../RegistrationNamespaces");
const Renderer = require("./HaPairRenderer");

class HaPairComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = _.get(value, "haPairName", "");
        this._entity = _.clone(value);
        this._gameEditor = context.gameEditor;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._value = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setData(newVal);
        }
    }

    getValue() {
        return this.getData();
    }

    setData(newVal) {
        this._value = newVal;
        this.emit("SetHaGroup", newVal);
        return this;
    }

    getData() {
        return this._value;
    }

    getEntity() {
        return this._entity;
    }

    getPairedDevice() {
        return this.getEntity()
            .loadRelatedHaPair({})
            .then((res) => {
                if (res) {
                    return Promise.resolve(res.id);
                } else {
                    return Promise.resolve();
                }
            });
    }
    openEditor(id) {
        let ids = [id];
        let title = this.getValue();
        let fqn = Registrations.DIE_VIEW_DETAILS;
        this._gameEditor.launchDeviceEditor(
            {
                fqn
            },
            {
                ids,
                title
            }
        );
    }
    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = HaPairComponent;
